import axios from 'axios';

export class RevalidationService {
    getRevalidationDetailsById = async (id) => {
        return await axios.get('/api/userrevalidation/revalidationdetails?id=' + id);
    };

    saveRevalidationSetup = async (revalidationSetup) => {
        return await axios.post('/api/userrevalidation/saverevalidationsetup', revalidationSetup);
    };

    deleteRevalidation = async (id) => {
        return await axios.delete('/api/userrevalidation/deleterevalidation?id=' + id);
    }
}
